import { Injectable } from '@angular/core';

import {
   HttpInterceptor,
   HttpRequest,
   HttpHandler,
   HttpEvent,
   HttpResponse,
   HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { ResponseWrapper } from './response.wrapper';
import { isAssets, isFullUrl } from './httpFunctions';
import { MockPath, MockPathOpts } from './mock-path.mock';

@Injectable()
export class MockHttpInterceptorBase implements HttpInterceptor {
   constructor() {}

   mockService: any;

   routes: MockPath<any>[] = [];

   intercept(
      request: HttpRequest<any>,
      next: HttpHandler,
   ): Observable<HttpEvent<any>> {
      if ( !this.isMock() || isAssets( request.url ) || isFullUrl( request.url )) {
         return next.handle( request );
      }

      if ( this.mockService?.mock ) {
         const collection = this.mockService.mock( request.method + request.url, request.body );
         console.log( '* mock - response', collection );

         return of( new HttpResponse<any>({ body: collection }) as HttpEvent<any> ).pipe( delay( 2000 ));
      }

      try {
         const response = this.stringify( this.handleMock( this.getMockPathOpts( request )));
         console.log( '* mock - response', request.method, request.url, response );

         return of( new HttpResponse<any>({ body: response }) as HttpEvent<any> ).pipe( delay( 2000 ));
      } catch( error ) {
         if ( error === 'bypass' ) {
            console.log( 'bypassing', request.url );

            return next.handle( request );
         } else {
            console.log( 'MockHttpInterceptorBase caught error', error );
         }
      }
   }

   isMock(): boolean {
      return false;
   }

   getMockPathOpts( request: HttpRequest<any> ): MockPathOpts {
      const [ url, split ] = request.url.split( '?' );
      const id = ( url.split( '/' ).slice( -1 )[0].match( /[0-9]+/ ) ?? [] )[0];

      return { verb: request.method, url: request.url, split, id, body: request?.body };
   }

   stringify( obj: any ) {
      return JSON.parse( JSON.stringify( obj ));
   }

   handleMock( opts: MockPathOpts ) {
      console.log( '* mock - opts', opts.verb, opts.url, opts );

      const wrapper = {
         messages: [],
         type: 'mock',
         response: { collection: [] }
      } as ResponseWrapper<any>;

      const matchedRoute = this.routes.filter( route => new RegExp( route.path ).test( opts.url ))
         .filter( route => route?.verb === opts.verb )[0];

      if ( matchedRoute ) {
         console.log( '* mock - found matchedRoute', matchedRoute );

         if ( matchedRoute?.bypass ) { throw 'bypass'; }

         const captured = opts.url.match( matchedRoute.path );
         if ( captured.length > 1 ) { opts.captured = captured.slice( 1 ); }

         if ( matchedRoute?.wrapper ) { return matchedRoute.wrapper( opts ); }

         if ( matchedRoute?.messages ) { wrapper.messages = matchedRoute.messages( opts ); }
         if ( matchedRoute?.type ) { wrapper.type = matchedRoute.type; }
         if ( matchedRoute?.response ) { wrapper.response = matchedRoute.response( opts ); }
         if ( matchedRoute?.collection ) { wrapper.response.collection = matchedRoute.collection( opts ); }
      }

      return wrapper;
   }
}

export let mockHttpInterceptor = {
   provide: HTTP_INTERCEPTORS,
   useClass: MockHttpInterceptorBase,
   multi: true
};
